import * as React from "react";
import classnames from "classnames";
import CheckboxView from "../../CheckboxView/CheckboxView/CheckboxView.js";
import ErrorMessage from "../../ErrorMessage/ErrorMessage/ErrorMessage.js";
const CheckboxWithLabel = ({
  className,
  checkboxClassName,
  ...rest
}) => {
  const errorIdFromMsg = rest.errorMessage ? `error_${rest.errorMessage?.replace(/[^A-Z0-9]/gi, "_")}` : void 0;
  const errorId = (rest.id ? `error_${rest.id}` : void 0) || errorIdFromMsg;
  return /* @__PURE__ */ React.createElement("div", { className: classnames("checkbox-with-label", className) }, /* @__PURE__ */ React.createElement(CheckboxView, { ...rest, errorId, className: checkboxClassName }), /* @__PURE__ */ React.createElement(ErrorMessage, { id: errorId || "", error: rest.error, errorMessage: rest.errorMessage }));
};
export {
  CheckboxWithLabel as default
};
//# sourceMappingURL=CheckboxWithLabel.js.map
